<template>
  <button type="button" class="btn">
    <slot></slot>
  </button>
</template>
